import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  src: "/img/check-green.svg",
  class: "modal__warning"
}
const _hoisted_2 = {
  key: 1,
  src: "/img/complain.svg",
  class: "modal__warning"
}
const _hoisted_3 = { class: "modal__title" }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal = _resolveComponent("app-modal")!

  return (_openBlock(), _createBlock(_component_app_modal, {
    visible: _ctx.model.show,
    "visible-cancel-btn": _ctx.model.type !== 'info' && !!_ctx.model.cancelBtnText,
    onCloseModal: _ctx.model.closePopup,
    onSubmit: _ctx.model.confirm,
    "cancel-button-text": _ctx.model.cancelBtnText,
    "submit-button-text": _ctx.model.submitBtnText,
    "submit-button-is-red": _ctx.model.type === 'warning'
  }, {
    content: _withCtx(() => [
      (_ctx.model.type === 'success')
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : (_ctx.model.type !== 'info')
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.model.message), 1),
      (_ctx.model.submessage)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString(_ctx.model.submessage), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "visible-cancel-btn", "onCloseModal", "onSubmit", "cancel-button-text", "submit-button-text", "submit-button-is-red"]))
}